export const environment = {
  production: false,
  // api_url: 'https://dev-legia-api.sso-tisa.com/admin',
  api_url: 'https://dev-ekstraklasa-api.sso-tisa.com/admin',
  // api_user_url: 'https://dev-legia-api.sso-tisa.com/admin/operator/profile',
  api_user_url: 'https://dev-ekstraklasa-api.sso-tisa.com/admin/operator/profile',

  services_panel: {
    id: 3,
    code: 'services-panel',
    label_pl: 'Panel serwisów'
  }
};
